let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ofbz")).then(() => parcelRequire('iaeCZ'));